import styles from './Account.module.css';

/**
 * Reusable section card matching the app's `.card` + green-dot title pattern.
 * `title`   - uppercase label shown next to the accent dot.
 * `actions` - optional node rendered on the right of the header (buttons, badge).
 */
export default function AccountCard({ title, description, actions, children, className = '' }) {
  return (
    <section className={`${styles.card} ${className}`}>
      {(title || actions) && (
        <div className={styles.cardHead}>
          {(title || description) && (
            <div className={styles.cardHeadText}>
              {title && (
                <div className={styles.cardTitle}>
                  <span className={styles.cardDot} />
                  {title}
                </div>
              )}
              {description && <div className={styles.cardDesc}>{description}</div>}
            </div>
          )}
          {actions && <div className={styles.cardActions}>{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}

/** Label / value row used inside cards. `icon` renders muted before the label. */
export function InfoRow({ label, icon, children, accent = false, strong = false, muted = false }) {
  const cls = [
    styles.infoValue,
    strong ? styles.infoValueStrong : '',
    accent ? styles.infoValueAccent : '',
    muted ? styles.infoValueMuted : '',
  ].join(' ').replace(/\s+/g, ' ').trim();
  return (
    <div className={styles.infoRow}>
      <span className={styles.infoLabel}>
        {icon && <span className={styles.infoLabelIcon}>{icon}</span>}
        {label}
      </span>
      <span className={cls}>{children}</span>
    </div>
  );
}
